import * as React from "react";

interface ITaxDetailsContext {
  zipCode?: string;
  setZipCode(value: string): void;
  country?: string;
  setCountry(value: string): void;
}

const TaxDetailsContext = React.createContext<ITaxDetailsContext>({} as ITaxDetailsContext);

interface IProps {
  children: React.ReactNode;
  defaultZipCode?: string;
  defaultCountryCode?: string;
}

export const TaxDetailsProvider = ({ children, defaultZipCode, defaultCountryCode }: IProps): JSX.Element => {
  const [zipCode, setZipCode] = React.useState(defaultZipCode);
  const [country, setCountry] = React.useState(defaultCountryCode);

  const value = React.useMemo(
    () => ({
      zipCode,
      setZipCode,
      country,
      setCountry,
    }),
    [zipCode, country]
  );

  return <TaxDetailsContext.Provider value={value}>{children}</TaxDetailsContext.Provider>;
};

export function useTaxDetails(): ITaxDetailsContext {
  const context = React.useContext(TaxDetailsContext);

  if (context === undefined) {
    throw new Error("useTaxDetails must be used within a TaxDetailsProvider");
  }

  return context;
}
